import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@material-ui/core';
import { showNotification as showNotificationAction } from 'react-admin';
import { push as pushAction } from 'react-router-redux';
import config from '../config';

const env = process.env.REACT_APP_CUSTOM_NODE_ENV;

const getBaseUrl = permissions => {
    if (permissions === 'partner_service') {
        return `${config[env].url}partner_service/`;
    }

    return `${config[env].url}admin/`;
};

const getDefaultText = ({ permissions, resource, withFine }) => {
    if (typeof withFine === 'boolean') {
        return withFine ? 'Списать штраф и закрыть' : 'Закрыть без штрафа';
    }

    if (permissions === 'partner_service' || resource === 'partner_service_sessions') {
        return 'Закрыть сессию';
    }

    return 'Списать штраф и закрыть';
};

class CloseSession extends Component {
    state = {
        disabled: false,
    };

    async setDisabled(disabled) {
        await this.setState({
            disabled: disabled,
        });
    }

    handleClick = () => {
        const { record, showNotification, push, resource, withFine } = this.props;
        const token = localStorage.getItem('token');
        const permissions = localStorage.getItem('permissions');
        const url = `${getBaseUrl(permissions)}${resource}/close_session`;
        const headers = new Headers({
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        });
        const body = {
            ...record,
            ...(typeof withFine === 'boolean' ? { with_fine: withFine } : {}),
        };
        this.setDisabled(true)
            .then(() => {
                showNotification('Запрос отправлен');
                return fetch(url, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers,
                });
            })
            .then(async response => {
                const data = await response.json();
                if (response.status === 200) {
                    showNotification(data.message);
                    await this.setDisabled(true);
                } else {
                    showNotification(data.message, 'warning');
                    await this.setDisabled(false);
                }
                push(`/${resource}`);
            })
            .catch(e => {
                this.setDisabled(false).then();
                console.error(e);
                showNotification('Ошибка: что-то пошло не так', 'warning');
                push(`/${resource}`);
            });
    };

    render() {
        const { label, resource, withFine } = this.props;
        const permissions = localStorage.getItem('permissions');
        const text =
            label ||
            getDefaultText({
                permissions,
                resource,
                withFine,
            });

        return (
            <Button
                onClick={this.handleClick}
                variant="contained"
                color={'primary'}
                style={{ marginLeft: '10px' }}
                disabled={
                    this.state.disabled ||
                    (this.props.record && !(this.props.record.status === 'active'))
                }
            >
                {text}
            </Button>
        );
    }
}

CloseSession.propTypes = {
    label: PropTypes.string,
    push: PropTypes.func,
    record: PropTypes.object,
    resource: PropTypes.string,
    showNotification: PropTypes.func,
    withFine: PropTypes.bool,
};

export default connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
})(CloseSession);
